import React from "react";
import { Youtube, Instagram, Twitch } from "lucide-react";
import { footerColumns } from "../mock";
import Logo from "./Logo";

const TikTokIcon = ({ size = 18 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path d="M16.5 3c.3 2.1 1.5 3.6 3.5 3.9v2.3c-1.2.1-2.4-.2-3.5-.8v5.9c0 3.4-2.6 5.9-5.9 5.9S4.7 15.9 4.7 12.5c0-3.1 2.3-5.5 5.4-5.8v2.4c-.3.05-.7.15-1 .3-1.2.5-2 1.7-2 3.1 0 1.9 1.5 3.4 3.4 3.4s3.4-1.5 3.4-3.4V3h2.6z" />
  </svg>
);

const Footer = () => {
  return (
    <footer className="relative border-t border-white/5 pt-16 pb-8 mt-10">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10 md:gap-8">
          <div>
            <Logo height={40} />
            <p className="font-serif-body text-[#8b8798] text-[0.95rem] mt-5 leading-relaxed max-w-[220px]">
              Live music reviews. Real reactions. Multi-platform broadcast.
            </p>
          </div>

          {footerColumns.map((col) => (
            <div key={col.title}>
              <h4 className="font-ui font-bold text-white text-[1.02rem] mb-4">{col.title}</h4>
              <ul className="space-y-3">
                {col.links.map((link) => (
                  <li key={link}>
                    <a href="#" className="text-[#8b8798] hover:text-white transition-colors text-[0.94rem]">
                      {link}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-14 pt-6 border-t border-white/5 flex flex-col sm:flex-row items-center justify-between gap-5">
          <p className="text-[#6f6a80] text-sm">© 2026 HSS Feed. All rights reserved.</p>
          <div className="flex items-center gap-5 text-[#8b8798]">
            <a href="#" className="hover:text-[#d8b4fe] transition-colors" aria-label="TikTok"><TikTokIcon size={19} /></a>
            <a href="#" className="hover:text-[#d8b4fe] transition-colors" aria-label="Instagram"><Instagram size={19} /></a>
            <a href="#" className="hover:text-[#d8b4fe] transition-colors" aria-label="YouTube"><Youtube size={19} /></a>
            <a href="#" className="hover:text-[#d8b4fe] transition-colors" aria-label="Twitch"><Twitch size={19} /></a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
